<template>
  <a-modal
    v-model:visible="show"
    centered
    :footer="null"
    :width="430"
    wrapClassName="encourage-modal"
    :bodyStyle="bodyStyle"
    :maskClosable="true"
    @cancel="handleClose"
  >
    <div class="wrap">
      <img src="~@/assets/img/encourage.png" class="img" />
      <div class="good">很棒哦！</div>
      <div class="text">转发来自虞董的棒棒棒～</div>
      <a-button type="primary" danger @click="handleClose">知道了</a-button>
    </div>
  </a-modal>
</template>
<script setup>
import { defineProps, defineEmits, computed } from 'vue'
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
const show = computed(() => props.visible)
const emit = defineEmits(['update:visible'])
const bodyStyle = {
  height: '286px',
  padding: 'initial'
}
const handleClose = () => {
  emit('update:visible', false)
}
</script>
<style scoped lang="scss">
.wrap {
  text-align: center;
  position: relative;
}
.img {
  width: 381px;
  height: 240px;
  margin-top: -98px;
}
.good {
  font-weight: 600;
  font-size: 24px;
  color: #000000e6;
  position: absolute;
  top: 109px;
  left: 50%;
  transform: translateX(-50%);
}
.text {
  margin-top: 20px;
  margin-bottom: 42px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
}
</style>
